module.exports = __webpack_public_path__ + "static/media/Earthquake.1d792365.jpg";